export const normalizeColor = (color: string) => {
    const regex = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i;
    const match = color.match(regex);
    if (match) {
        const [, r, g, b] = match;
        return `${Number(r)},${Number(g)},${Number(b)}`;
    }
    return color;
};

export const compareColors = (colorA: string, colorB: string) => {
    const normA = normalizeColor(colorA).split(',').map(Number);
    const normB = normalizeColor(colorB).split(',').map(Number);
    for (let i = 0; i < 3; i++) {
        if (normA[i] < normB[i]) return -1;
        if (normA[i] > normB[i]) return 1;
    }
    return 0;
};

// Get next permutation of colors
export const nextPermutation = (colorArray: string[]) => {
    const arrCopy = [...colorArray];
    let k = arrCopy.length - 2;
    while (k >= 0 && compareColors(arrCopy[k], arrCopy[k + 1]) >= 0) {
        k--;
    }
    if (k < 0) {
        arrCopy.reverse();
        return arrCopy;
    }
    let l = arrCopy.length - 1;
    while (compareColors(arrCopy[k], arrCopy[l]) >= 0) {
        l--;
    }
    [arrCopy[k], arrCopy[l]] = [arrCopy[l], arrCopy[k]];
    let left = k + 1,
        right = arrCopy.length - 1;
    while (left < right) {
        [arrCopy[left], arrCopy[right]] = [arrCopy[right], arrCopy[left]];
        left++;
        right--;
    }
    return arrCopy;
};
